<label *ngIf="hasLabel()" class="label" for="{{INDRA_printID}}">{{printLabel()}}</label>

<ng-container *ngIf="parentForm">
    <div class="select-wrapper {{ INDRA_selectWrapperStyles() }}" (click)="handleSelectClick()" [formGroup]="parentForm">
        <select selectbox [attr.aria-label]="arialabel ? arialabel : false" class="select" [ngClass]="INDRA_selectStyles()" (blur)="handleSelectBlur()" (change)="change($event)" [formControlName]="formControlName" [attr.disabled]="disabled ? '' : null" id="{{INDRA_printID}}">
			<option *ngIf="hasPlaceholder() || showPlaceholder" [ngValue]="null" disabled selected default hidden>{{printPlaceholder()}}</option>
			<option [ngValue]="null">{{printPlaceholder()}}</option>
			<option *ngFor="let option of inputOptions" [value]="option.value" [disabled]="option.disabled" [ngClass]="option.disabled ? 'option_disabled' : ''">
				<span *ngIf="PAX_TYPE_SPONSOR == option.value">
					<span class="sponsor">Sponsor</span>
					 - 
				</span>{{option.label}}
			</option>
		</select>
    </div>
</ng-container>

<ng-container *ngIf="!parentForm">
    <div class="select-wrapper {{ INDRA_selectWrapperStyles() }}" (click)="handleSelectClick()">
        <select selectbox [attr.aria-label]="arialabel" class="select" [ngClass]="INDRA_selectStyles()" (blur)="handleSelectBlur()" (change)="change($event)" [(ngModel)]="value" id="{{INDRA_printID}}" [attr.disabled]="disabled ? '' : null">
			<option *ngIf="hasPlaceholder() || showPlaceholder" [ngValue]="null" disabled selected default hidden>{{printPlaceholder()}}</option>
			<option *ngFor="let option of inputOptions" [value]="option.value" [disabled]="option.disabled" [ngClass]="option.disabled ? 'option_disabled' : ''">
				<span *ngIf="PAX_TYPE_SPONSOR == option.value">
					<span class="sponsor">Sponsor</span>
					 - 
				</span>{{option.label}}
			</option>
		</select>
    </div>
</ng-container>

<span class="input-error" *ngIf="INDRA_showError">{{INDRA_printError()}}</span>